import PropertiesGrid from '@/components/PropertiesGrid/PropertiesGrid';
import { useAppContext } from '@/contexts/AppContext';
import { useUnits } from '@/hooks/units';
import { useMemo, type FC } from 'react';

interface Props {
  unitId: number;
}

const SimilarPropertiesSection: FC<Props> = ({ unitId }) => {
  const { community } = useAppContext();
  const { data: units } = useUnits.useSuspenseQuery([community.id]);

  const similarProperties = useMemo(
    () => (units ?? []).filter((unit) => unit.id !== unitId).slice(0, 3),
    [units, unitId],
  );

  if (similarProperties.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Similar Floor Plans</h2>
        <PropertiesGrid units={similarProperties} />
      </div>
    </section>
  );
};

export default SimilarPropertiesSection;
